/// <amd-module name="VSSUI/Components/VssDetailsList/VssDetailsListTitleCell" />

import * as React from "react";
import { Link } from "VSSUI/Link";
import { Tooltip } from "VSSUI/TooltipEx";
import { BaseComponent } from "OfficeFabric/Utilities";
import { css } from "VSSUI/Util";
import { IVssDetailsListTitleCellProps } from "../../Components/VssDetailsList/VssDetailsList.Props";
import { ItemIndicatorSet } from "VSSUI/ItemIndicator";
import { VssIcon, VssIconType } from "VSSUI/VssIcon";

/**
 * Helper for the styling / functionality of common title cells in VssDetailsList
 */
/** @deprecated */
export class VssDetailsListTitleCell extends BaseComponent<IVssDetailsListTitleCellProps> {
    public render(): JSX.Element {
        const { secondaryText, onRenderSecondaryText, ariaLabel, iconProps } = this.props;

        if (secondaryText || onRenderSecondaryText) {
            return (
                <div className={css("vss-DetailsList--titleCellTwoLine", !iconProps && "noIcon")} aria-label={ariaLabel}>
                    {this._renderIcon()}
                    <div className="vss-DetailsList--titleCellTwoLineText">
                        {this._renderPrimaryText()}
                        {this._renderSecondaryText()}
                    </div>
                    {this._renderIndicators()}
                </div>
            );
        } else {
            return (
                <div className="vss-DetailsList--titleCellOneLine" aria-label={ariaLabel}>
                    {this._renderIcon()}
                    {this._renderPrimaryText()}
                    {this._renderIndicators()}
                </div>
            );
        }
    }

    private _renderPrimaryText(): JSX.Element {
        const { primaryText, primaryAction, primaryTarget, disabled, onRenderPrimaryText } = this.props;
        let { primaryActionRole } = this.props;

        const textElement = onRenderPrimaryText ? (
            onRenderPrimaryText()
        ) : primaryAction ? (
            typeof primaryAction === "function" ? (
                <Link
                    className={css("vss-DetailsList--titleCellText", disabled && "disabled")}
                    role={primaryActionRole || "button"}
                    href="#"
                    onClick={primaryAction}
                >
                    {primaryText}
                </Link>
            ) : (
                <Link
                    className={css("vss-DetailsList--titleCellText", disabled && "disabled")}
                    role={primaryActionRole || "link"}
                    href={primaryAction}
                    target={primaryTarget}
                >
                    {primaryText}
                </Link>
            )
        ) : (
            <span className={css("vss-DetailsList--titleCellText", disabled && "disabled")}>{primaryText}</span>
        );

        return <div className="vss-DetailsList--titleCellPrimary">{textElement}</div>;
    }

    private _renderSecondaryText(): JSX.Element {
        const { secondaryText, disabled, onRenderSecondaryText } = this.props;

        const textElement = onRenderSecondaryText ? (
            onRenderSecondaryText()
        ) : (
            <Tooltip overflowOnly={true} text={secondaryText}>
                <div className="flex flex-grow text-ellipsis">
                    <span className={css("vss-DetailsList--titleCellText", disabled && "disabled")}>{secondaryText}</span>
                </div>
            </Tooltip>
        );

        if (textElement) {
            return <div className="vss-DetailsList--titleCellSecondary">{textElement}</div>;
        }

        return null;
    }

    private _renderIcon(): JSX.Element {
        const { iconProps, disabled } = this.props;
        if (iconProps) {
            return (
                <VssIcon
                    {...iconProps}
                    className={css(
                        "vss-DetailsList--titleCellIcon",
                        iconProps.className,
                        disabled && "disabled",
                        iconProps.iconType === VssIconType.image && "vss-DetailsList--titleCellIcon--image"
                    )}
                />
            );
        }
        return null;
    }

    private _renderIndicators(): JSX.Element {
        const indicators = this.props.indicators
            ? this.props.indicators.map(indicator => {
                  return indicator.getItemIndicator();
              })
            : [];

        return indicators && indicators.length > 0 ? <ItemIndicatorSet indicators={indicators} /> : null;
    }
}
